export const scrollSetup = {
  vuescroll: {},
  scrollPanel: {
    easing: "easeInCubic"
  },
  rail: {
    size: "8px"
  },
  bar: {
    background: "#0277bd",
    size: "8px"
  }
};

// Set up header for club table which is from Leagues.vue component
export const clubsTableHeader = [
  {
    text: "Name",
    align: "start",
    sortable: false,
    value: "club_name"
  },
  { text: "Description", value: "club_description" },
  { text: "Teams", value: "teams_quantity" },
  { text: "Foundation", value: "foundation_time" },
  { text: "Actions", value: "actions", sortable: false }
];

export const sportTypes = [
  "SWIMMING",
  "WATERPOLO",
  "CYCLING",
  "RUNNING",
  "DRYLAND",
  "Aikido",
  "TENNIS"
];
// eslint-disable-next-line no-useless-escape
const emailRegexp = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;

// Set up validation rules
export const validationRules = {
  name: [
    v => !!v || "Name is required",
    v => (v && v.length <= 50) || "Name must be less than 50 characters"
  ],
  required: [v => !!v || "Value is required"],
  email: [
    v => !!v || "E-mail is required",
    v => emailRegexp.test(v) || "E-mail must be valid"
  ],
  type: [
    v => !!v || "Type is required",
    v => (v && v.length <= 50) || "Type must be less than 50 characters"
  ],
  logo: [
    // In future we cant remake logo logic
    v => !!v || "Logo is required"
  ],
  website: [
    v =>
      // eslint-disable-next-line no-useless-escape
      /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/.test(
        v
      ) || "Website name must be valid (http/https://domain.com)"
  ],
  description: [
    v => !!v || "Description is required",
    v =>
      (v && v.length <= 300) || "Description must be less than 300 characters"
  ],
  password: [
    password => !!password || "Password is required",
    password => password.length >= 4 || "Password must be at least 4 characters"
  ],
  urlRules: [v => /^(http|https):\/\/[^ "]+$/.test(v) || "URL must be valid"]
};

export const routeWithoutFooter = [
  { name: "Leagues", path: "/admin/leagues" },
  { name: "ClubList", path: "/admin/club_list" }
];

export const youtubeUrlParser = url => {
  // eslint-disable-next-line no-useless-escape
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length == 11) {
    return match[2];
  } else {
    console.error("Url doesn't match");
    return false;
  }
};

export const apiKeys = {
  googleDesktopClientId:
    "215787842521-ngicif6p8cunqkgd80ppjsr7672jn3ro.apps.googleusercontent.com",
  googleClientId:
    "215787842521-b1q9q72o2i9tibjhks1ul4fed204vkfu.apps.googleusercontent.com",
  googleApiKey: "AIzaSyAABm0LhCW6N65IQS7XtIQKUO4w-UXA1_s"
};
